import { DocumentationSection } from '@/hooks/useDocumentation';
import { Card } from '@/components/ui/card';
import ReactMarkdown from 'react-markdown';

interface ManualViewerProps {
  section: DocumentationSection | null;
}

export function ManualViewer({ section }: ManualViewerProps) {
  if (!section) {
    return (
      <Card className="p-6 h-full flex items-center justify-center">
        <p className="text-muted-foreground">Selecteer een sectie om te bekijken</p>
      </Card>
    );
  }

  return (
    <Card className="p-6 h-full overflow-y-auto">
      <div className="prose prose-sm max-w-none dark:prose-invert">
        <ReactMarkdown>{section.content}</ReactMarkdown>
      </div>
    </Card>
  );
}
